import { useCallback } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';

import {
  photosAndVideosUpload as photosAndVideosUploadAction,
  photosUpload as photosUploadAction,
  uploadCancel as uploadCancelAction,
  uploadReset as uploadResetAction,
  videoUpload as videoUploadAction,
} from './fileUploadActions';

const useFileUpload = () => {
  const { getState } = useStore();
  const dispatch = useDispatch();
  const {
    files = [],
    inProgress = [],
    completed = [],
    failed = [],
    uploading = false,
    complete = false,
    current = 0,
    canceled = false,
    cancelToken = undefined,
  } = useSelector(({ pro }) => pro.fileUpload);

  const uploadReset = useCallback(() => dispatch(uploadResetAction()), [
    dispatch,
  ]);
  const uploadCancel = useCallback(() => dispatch(uploadCancelAction()), [
    dispatch,
  ]);
  const photosUpload = useCallback(
    async args => {
      const result = await photosUploadAction({
        ...args,
        dispatch,
        getState,
      });
      return result;
    },
    [dispatch, getState],
  );
  const videoUpload = useCallback(
    async args => {
      const result = await videoUploadAction({ ...args, dispatch });
      return result;
    },
    [dispatch],
  );
  const photosAndVideosUpload = useCallback(
    async args => {
      const result = await photosAndVideosUploadAction({
        ...args,
        dispatch,
        getState,
      });
      return result;
    },
    [dispatch, getState],
  );

  return {
    // Reducer parameters
    files,
    inProgress,
    completed,
    failed,
    uploading,
    complete,
    current,
    canceled,
    cancelToken,
    //  Dispatched actions
    uploadReset,
    uploadCancel,
    photosUpload,
    videoUpload,
    photosAndVideosUpload,
  };
};

export default useFileUpload;
